var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85938 6.5C4.86902 6.5 5.6875 5.68152 5.6875 4.67188C5.6875 3.66223 4.86902 2.84375 3.85938 2.84375C2.84973 2.84375 2.03125 3.66223 2.03125 4.67188C2.03125 5.68152 2.84973 6.5 3.85938 6.5Z",
    fill: "#DADADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94141 7.51562C5.22641 7.15254 4.43727 7.00781 3.85938 7.00781C2.72746 7.00781 0.40625 7.70199 0.40625 9.08984V10.1562H4.21484V9.74822C4.21484 9.2658 4.41797 8.78211 4.77344 8.37891C5.05705 8.05695 5.45416 7.75811 5.94141 7.51562Z",
    fill: "#DADADA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63281 7.3125C7.31072 7.3125 4.67188 8.12906 4.67188 9.75V10.9688H12.5938V9.75C12.5938 8.12906 9.9549 7.3125 8.63281 7.3125Z",
    fill: "#DADADA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63281 6.5C9.86682 6.5 10.8672 5.49964 10.8672 4.26562C10.8672 3.03161 9.86682 2.03125 8.63281 2.03125C7.3988 2.03125 6.39844 3.03161 6.39844 4.26562C6.39844 5.49964 7.3988 6.5 8.63281 6.5Z",
    fill: "#DADADA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/usersIcon.583a9c63.svg";
export { ForwardRef as ReactComponent };